import { render } from "./OrderSearch.vue?vue&type=template&id=6c65b907&scoped=true"
import script from "./OrderSearch.vue?vue&type=script&lang=js"
export * from "./OrderSearch.vue?vue&type=script&lang=js"

import "./OrderSearch.vue?vue&type=style&index=0&id=6c65b907&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c65b907"]])

export default __exports__